module.exports = __webpack_public_path__ + "static/media/home.c21346d1.svg";